/* Donavello Mutfağı — tema davranışları (bağımlılık: yalnızca ana sayfada GSAP) */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    const fmt = window.DNV_MONEY || '{{amount}} TL';
    const n = cents / 100;
    const two = (sep, dec) => {
      const [i, d] = n.toFixed(2).split('.');
      const int = i.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return d === '00' ? int : int + dec + d;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: two(',', '.'), amount_no_decimals: two(',', '.').split('.')[0],
      amount_with_comma_separator: two('.', ','), amount_no_decimals_with_comma_separator: two('.', ',').split(',')[0],
      amount_with_apostrophe_separator: two("'", '.')
    }[k] || two(',', '.')));
  }

  /* ------------------------------------------------------------------
     SEPET
     ------------------------------------------------------------------ */
  const drawer = document.getElementById('cart-drawer');
  let lastFocus = null;

  function openDrawer() {
    if (!drawer) { location.href = ROOT + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.inert = false;
    const close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.inert = true;
    setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 420);
    if (lastFocus) lastFocus.focus();
  }
  window.dnvOpenCartDrawer = openDrawer;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; });
  }

  // sepet paneli ve sepet sayfası sunucuda yeniden çizilir (Section Rendering API)
  async function refreshCart() {
    const ids = ['cart-drawer'];
    if (document.getElementById('shopify-section-main-cart')) ids.push('main-cart');
    const res = await fetch(`${ROOT}?sections=${ids.join(',')}`);
    const html = await res.json();
    ids.forEach(id => {
      const target = document.getElementById(`shopify-section-${id}`);
      if (!target || !html[id]) return;
      const doc = new DOMParser().parseFromString(html[id], 'text/html');
      const fresh = doc.getElementById(`shopify-section-${id}`);
      if (!fresh) return;
      if (id === 'cart-drawer') {
        // panelin açık/kapalı durumunu koru, yalnızca içeriği değiştir
        const inner = target.querySelector('[data-drawer-content]');
        const freshInner = fresh.querySelector('[data-drawer-content]');
        if (inner && freshInner) inner.replaceWith(freshInner);
      } else {
        target.innerHTML = fresh.innerHTML;
      }
    });
    const cart = await (await fetch(ROOT + 'cart.js')).json();
    setCount(cart.item_count);
    syncReorderButtons();
    tidyTitles();
    // teslimat bölgesi seçimleri yeni çizilen kutulara geri yüklenir
    if (window.dnvDeliveryAreaRestore) window.dnvDeliveryAreaRestore();
    return cart;
  }
  window.dnvRefreshCartDrawer = refreshCart;

  async function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
      await refreshCart();
      if (btn) {
        btn.classList.add('is-added');
        const label = btn.querySelector('[data-label]');
        if (label) { const old = label.textContent; label.textContent = 'Eklendi'; setTimeout(() => { label.textContent = old; btn.classList.remove('is-added'); }, 1600); }
      }
      openDrawer();
      return true;
    } catch (err) {
      const box = btn && btn.closest('form, .dish, .product__info, .qv__body');
      const out = box && box.querySelector('[data-form-error]');
      if (out) { out.textContent = err.message; out.hidden = false; }
      else alert(err.message);
      return false;
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }

  async function changeLine(key, quantity) {
    const res = await fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      alert(data.description || 'Sepet güncellenemedi.');
    }
    await refreshCart();
  }

  // son sipariş: ödeme adımına geçerken sepet tarayıcıda saklanır (canlı temadaki davranış)
  const LAST_ORDER_KEY = 'dnv_last_order_v1';
  function snapshotCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    try { localStorage.setItem(LAST_ORDER_KEY, JSON.stringify(cart.items.map(i => ({ id: i.variant_id, quantity: i.quantity })))); } catch (e) {}
  }
  function lastOrder() {
    try { const items = JSON.parse(localStorage.getItem(LAST_ORDER_KEY) || 'null'); return items && items.length ? items : null; } catch (e) { return null; }
  }
  function syncReorderButtons() {
    const has = !!lastOrder();
    document.querySelectorAll('.dnv-reorder-btn').forEach(b => { b.hidden = !has; });
  }

  function applyDiscount(input) {
    const code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
  }

  document.addEventListener('click', async e => {
    const t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    const quick = t.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: +quick.dataset.quickAdd, quantity: 1 }], quick); return; }

    const qtyBtn = t.closest('button[data-line-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const line = qtyBtn.closest('[data-line-key]');
      if (line.classList.contains('is-busy')) return;
      line.classList.add('is-busy');
      const cur = +line.dataset.lineCurrent;
      changeLine(line.dataset.lineKey, Math.max(0, cur + (+qtyBtn.dataset.lineQty)));
      return;
    }
    const rm = t.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      const line = rm.closest('[data-line-key]');
      if (line.classList.contains('is-busy')) return;
      line.classList.add('is-busy');
      changeLine(line.dataset.lineKey, 0);
      return;
    }

    const disc = t.closest('[data-discount-apply]');
    if (disc) { e.preventDefault(); applyDiscount(disc.closest('.dnv-cart-discount').querySelector('input')); return; }

    const reorder = t.closest('.dnv-reorder-btn');
    if (reorder) {
      e.preventDefault();
      const items = lastOrder();
      if (!items) return;
      reorder.disabled = true;
      const ok = await addToCart(items, null);
      reorder.disabled = false;
      if (!ok) alert('Son siparişindeki bazı ürünler artık mevcut değil, sepete eklenemedi.');
      return;
    }

    // ödeme: teslimat bölgesi doğrulaması (dnv-delivery-area, yakalama aşamasında) geçtiyse buraya gelir
    const checkout = t.closest('a.checkout-button, a.button-checkout');
    if (checkout) {
      e.preventDefault();
      try { snapshotCart(await (await fetch(ROOT + 'cart.js')).json()); } catch (err) {}
      location.href = checkout.href;
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (e.key === 'Enter' && e.target.matches('.dnv-cart-discount__input')) { e.preventDefault(); applyDiscount(e.target); }
  });
  syncReorderButtons();

  /* ------------------------------------------------------------------
     SEÇENEK PENCERESİ: "Seç" → seçenekler → doğrudan sepete
     ------------------------------------------------------------------ */
  const qv = document.getElementById('quick-view');
  let qvReturn = null;
  const qvOpen = () => qv && !qv.hidden;
  window.dnvQuickViewOpen = qvOpen;
  function closeQV() {
    if (!qvOpen()) return;
    qv.classList.remove('is-open'); qv.inert = true;
    document.documentElement.classList.remove('qv-lock');
    setTimeout(() => { if (!qv.classList.contains('is-open')) qv.hidden = true; }, 280);
    if (qvReturn) qvReturn.focus();
  }
  async function openQV(link) {
    if (!qv) { location.href = link.href; return; }
    qvReturn = link;
    const card = link.closest('.dish, [data-tab-scope], .cat-block');
    const brand = card ? getComputedStyle(card).getPropertyValue('--brand').trim() : '';
    if (brand) qv.style.setProperty('--brand', brand);
    const img = qv.querySelector('[data-qv-image]');
    img.src = link.dataset.qvImg || ''; img.classList.toggle('is-photo', link.hasAttribute('data-qv-photo'));
    qv.querySelector('[data-qv-link]').href = link.href;
    const title = qv.querySelector('[data-qv-title]'), price = qv.querySelector('[data-qv-price]'), box = qv.querySelector('[data-qv-options]'), err = qv.querySelector('[data-qv-error]');
    title.textContent = link.closest('.dish')?.querySelector('.dish__txt b')?.textContent || '';
    price.textContent = ''; box.innerHTML = '<p class="qv__hint">Seçenekler yükleniyor…</p>'; err.hidden = true;
    qv.hidden = false; qv.inert = false;
    document.documentElement.classList.add('qv-lock');
    requestAnimationFrame(() => qv.classList.add('is-open'));
    qv.querySelector('.qv__close').focus();
    let product;
    try {
      const res = await fetch(`${ROOT}products/${link.dataset.quickView}.js`);
      if (!res.ok) throw new Error();
      product = await res.json();
    } catch (e) { location.href = link.href; return; }
    title.textContent = tidyTitle(product.title);
    const opts = product.options.map(o => typeof o === 'string' ? { name: o } : o);
    const showPrice = v => { price.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '') + formatMoney(v.price); };
    const add = async (variant, qty, btn) => {
      err.hidden = true;
      const ok = await addToCart([{ id: variant.id, quantity: qty }], btn);
      if (ok) closeQV(); else { err.textContent = 'Ürün sepete eklenemedi, lütfen tekrar deneyin.'; err.hidden = false; }
    };
    if (opts.length === 1) {
      // tek seçenek: her değer bir buton; dokununca doğrudan sepete eklenir
      const first = product.variants.find(v => v.available) || product.variants[0];
      showPrice(first);
      box.innerHTML = `<p class="qv__hint">${opts[0].name} seçin, ürün sepetinize eklensin.</p><div class="qv__choices">` +
        product.variants.map(v => `<button type="button" class="qv__choice" data-v="${v.id}" ${v.available ? '' : 'disabled'}><span>${v.option1}</span><b>${v.available ? formatMoney(v.price) : 'Tükendi'}</b></button>`).join('') + '</div>';
      box.querySelectorAll('[data-v]').forEach(b => b.addEventListener('click', () => add(product.variants.find(v => v.id === +b.dataset.v), 1, b)));
    } else {
      // birden fazla seçenek: her biri seçilir, fiyat güncellenir, "Sepete ekle"
      const start = product.variants.find(v => v.available) || product.variants[0];
      box.innerHTML = opts.map((o, i) => {
        const values = [...new Set(product.variants.map(v => v.options[i]))];
        return `<fieldset class="option"><legend>${o.name}</legend><div class="option__values">` +
          values.map(val => `<label><input type="radio" name="qv-o${i}" value="${val.replace(/"/g, '&quot;')}" ${start.options[i] === val ? 'checked' : ''}><span>${val}</span></label>`).join('') +
          '</div></fieldset>';
      }).join('') + `<button type="button" class="btn btn--block" data-qv-add><span data-label>Sepete ekle</span></button>`;
      const btn = box.querySelector('[data-qv-add]');
      const current = () => {
        const chosen = opts.map((o, i) => (box.querySelector(`input[name="qv-o${i}"]:checked`) || {}).value);
        return product.variants.find(v => v.options.every((x, i) => x === chosen[i]));
      };
      const sync = () => {
        const v = current();
        btn.disabled = !v || !v.available;
        btn.querySelector('[data-label]').textContent = !v ? 'Bu seçenek yok' : v.available ? `Sepete ekle · ${formatMoney(v.price)}` : 'Tükendi';
        if (v) showPrice(v);
      };
      box.addEventListener('change', sync); sync();
      btn.addEventListener('click', () => { const v = current(); if (v) add(v, 1, btn); });
    }
  }
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-quick-view]');
    if (link) { e.preventDefault(); openQV(link); return; }
    if (e.target.closest('[data-qv-close]')) { e.preventDefault(); closeQV(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && qvOpen()) closeQV(); });

  /* ------------------------------------------------------------------
     ÜRÜN SAYFASI: seçenekler → varyant
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const json = form.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const btn = form.querySelector('[data-add]');
    const priceEl = document.querySelector('[data-product-price]');
    const pointsEl = document.querySelector('[data-product-points]');
    const qty = form.querySelector('[data-qty]');
    const money = formatMoney;

    function update() {
      const chosen = [...form.querySelectorAll('.option')].map(fs => (fs.querySelector('input:checked') || {}).value);
      const v = product.variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.querySelector('[data-label]').textContent = 'Bu seçenek yok'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.querySelector('[data-label]').textContent = v.available ? 'Sepete ekle' : 'Tükendi';
      if (priceEl) priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '') + money(v.price);
      if (pointsEl) pointsEl.textContent = `Bu üründen ${Math.floor(v.price / 10)} puan kazanacaksın`;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    form.addEventListener('change', e => { if (e.target.closest('.option')) update(); });
    form.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
      qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.step));
    }));
    form.addEventListener('submit', e => {
      e.preventDefault();
      const err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
      addToCart([{ id: +idInput.value, quantity: Math.max(1, +qty.value || 1) }], btn);
    });
  });

  /* ------------------------------------------------------------------
     KATEGORİ SEKMELERİ (ana sayfa marka sahneleri)
     ------------------------------------------------------------------ */
  const G = window.gsap;
  let tabTl = null;
  function selectTab(tabs, btn) {
    const btns = [...tabs.querySelectorAll('[role="tab"]')];
    const scope = tabs.closest('[data-tab-scope]');
    const cur = scope.querySelector('.panel:not([hidden])');
    const next = document.getElementById(btn.getAttribute('aria-controls'));
    btn.focus();
    if (cur === next) return;
    const dir = btns.indexOf(btn) > btns.findIndex(b => b.getAttribute('aria-controls') === cur.id) ? 1 : -1;
    btns.forEach(b => { const on = b === btn; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; });
    if (tabTl && tabTl.isActive()) tabTl.progress(1);
    if (!G || reduce) { cur.hidden = true; next.hidden = false; next.scrollLeft = 0; scope.dispatchEvent(new Event('dnv:panel')); return; }
    const curImgs = cur.querySelectorAll('.dish__img img'), curTxt = cur.querySelectorAll('.dish__txt > *');
    // çok kartlı panellerde (İçecekler) sırayla gelme toplamı ~0,5 sn'yi geçmesin
    const nNext = next.querySelectorAll('.dish').length || 1;
    const st = Math.min(.07, .5 / nNext), stTxt = Math.min(.06, .45 / nNext);
    tabTl = G.timeline()
      .to(curTxt, { opacity: 0, y: 10, duration: .18, stagger: { amount: .1 }, ease: 'power2.in' }, 0)
      .to(curImgs, { x: -dir * 140, rotate: -dir * 90, opacity: 0, duration: .32, stagger: .04, ease: 'power2.in' }, 0)
      .add(() => { cur.hidden = true; next.hidden = false; G.set([...curImgs, ...curTxt], { clearProps: 'transform,opacity' }); next.scrollLeft = 0; scope.dispatchEvent(new Event('dnv:panel')); })
      .fromTo(next.querySelectorAll('.dish__img img'), { x: dir * 180, rotate: dir * 140, opacity: 0 },
        { x: 0, rotate: 0, opacity: 1, duration: .6, stagger: st, ease: 'power3.out' })
      .fromTo(next.querySelectorAll('.dish__txt > *'), { opacity: 0, y: 14 },
        { opacity: 1, y: 0, duration: .4, stagger: { amount: Math.min(.45, stTxt * nNext) }, ease: 'power3.out', clearProps: 'transform,opacity' }, '-=.42');
  }
  document.querySelectorAll('[role="tablist"]').forEach(tabs => {
    const btns = [...tabs.querySelectorAll('[role="tab"]')];
    btns.forEach(b => b.addEventListener('click', () => selectTab(tabs, b)));
    tabs.addEventListener('keydown', e => {
      const i = btns.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); selectTab(tabs, btns[(i + 1) % btns.length]); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); selectTab(tabs, btns[(i - 1 + btns.length) % btns.length]); }
    });
  });

  /* ------------------------------------------------------------------
     TELEFON: tabak sırası yana kayar → noktalar, oklar ve ilk açılışta kayma ipucu
     ------------------------------------------------------------------ */
  const mobile = matchMedia('(max-width: 820px)');
  const chevron = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
  function setupSwipe(scope) {
    const panels = scope.querySelector('.panels');
    if (!panels || scope.querySelector('.swipe-ui')) return;
    const ui = document.createElement('div');
    ui.className = 'swipe-ui copy';
    ui.innerHTML = `<button type="button" class="swipe-ui__arrow" data-dir="-1" aria-label="Önceki ürün">${chevron('M15 5l-7 7 7 7')}</button>
      <div class="swipe-dots" role="group" aria-label="Ürünler"></div>
      <button type="button" class="swipe-ui__arrow" data-dir="1" aria-label="Sonraki ürün">${chevron('M9 5l7 7-7 7')}</button>`;
    panels.after(ui);
    const dots = ui.querySelector('.swipe-dots');
    const visible = () => scope.querySelector('.panel:not([hidden])');
    const cards = p => p ? [...p.querySelectorAll('.dish')] : [];
    const indexOf = p => {
      const cs = cards(p); if (!cs.length) return 0;
      const mid = p.scrollLeft + p.clientWidth / 2;
      let best = 0, bestD = Infinity;
      cs.forEach((c, i) => { const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
      return best;
    };
    const go = (p, i) => { const c = cards(p)[i]; if (c) p.scrollTo({ left: c.offsetLeft + c.offsetWidth / 2 - p.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' }); };
    function render() {
      const p = visible(), cs = cards(p);
      ui.hidden = !mobile.matches || cs.length < 2;
      if (ui.hidden) return;
      if (dots.children.length !== cs.length) {
        dots.innerHTML = cs.map((c, i) => `<button type="button" aria-label="${i + 1}. ürün"></button>`).join('');
      }
      const cur = indexOf(p);
      [...dots.children].forEach((d, i) => d.setAttribute('aria-current', i === cur ? 'true' : 'false'));
      ui.querySelector('[data-dir="-1"]').disabled = cur === 0;
      ui.querySelector('[data-dir="1"]').disabled = cur === cs.length - 1;
    }
    ui.addEventListener('click', e => {
      const p = visible();
      const arrow = e.target.closest('[data-dir]');
      if (arrow) { go(p, Math.max(0, Math.min(cards(p).length - 1, indexOf(p) + (+arrow.dataset.dir)))); return; }
      const dot = e.target.closest('.swipe-dots button');
      if (dot) go(p, [...dots.children].indexOf(dot));
    });
    let raf = 0;
    scope.querySelectorAll('.panel').forEach(p => p.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(render); }, { passive: true }));
    scope.addEventListener('dnv:panel', () => { dots.innerHTML = ''; requestAnimationFrame(render); });
    mobile.addEventListener('change', render);
    render();
    scope.__swipeRender = render;
  }
  // ilk kez görülen markada tabak sırası kısa bir an kayıp geri gelir: "yana kaydırılabilir" ipucu
  const nudged = new Set();
  function nudge(scope) {
    if (!mobile.matches || reduce || !scope || nudged.has(scope.id)) return;
    try { if (sessionStorage.getItem('dnv_nudge_' + scope.id)) return; } catch (e) {}
    const p = scope.querySelector('.panel:not([hidden])');
    if (!p || p.scrollWidth <= p.clientWidth + 10 || p.scrollLeft > 4) return;
    nudged.add(scope.id);
    try { sessionStorage.setItem('dnv_nudge_' + scope.id, '1'); } catch (e) {}
    setTimeout(() => {
      if (p.scrollLeft > 4) return;
      // mıknatıslı kaydırma (scroll-snap) küçük kaymayı hemen geri çeker; ipucu süresince kapatılır
      p.style.scrollSnapType = 'none';
      p.scrollTo({ left: Math.min(90, p.scrollWidth - p.clientWidth), behavior: 'smooth' });
      setTimeout(() => p.scrollTo({ left: 0, behavior: 'smooth' }), 650);
      setTimeout(() => { p.style.scrollSnapType = ''; }, 1300);
    }, 1100);
  }
  // Shopify'da BÜYÜK HARFLE girilmiş ürün adları Türkçe kurallarıyla düzeltilir (BURGAMİ BURGER 3'LÜ → Burgami Burger 3'lü)
  function tidyTitle(t) {
    const letters = t.replace(/[^A-Za-zÇĞİÖŞÜçğıöşü]/g, '');
    if (letters.length < 3 || letters !== letters.toLocaleUpperCase('tr')) return t;
    return t.toLocaleLowerCase('tr').replace(/(^|[\s(\-\/&])(\p{L})(?=\p{L})/gu, (m, a, b) => a + b.toLocaleUpperCase('tr'));
  }
  window.dnvTidyTitle = tidyTitle;
  function tidyTitles(root) {
    (root || document).querySelectorAll('.dish__txt b a, .product h1, .line__title').forEach(el => {
      if (el.children.length) return;
      const t = el.textContent.trim(), fixed = tidyTitle(t);
      if (fixed !== t) el.textContent = fixed;
    });
  }
  tidyTitles();
  document.querySelectorAll('[data-tab-scope]').forEach(setupSwipe);

  /* ------------------------------------------------------------------
     ANA SAYFA SAHNELERİ: her kaydırma tam bir marka
     ------------------------------------------------------------------ */
  const stage = document.querySelector('.stage[data-stage]');
  if (stage && !stage.querySelector('.slide')) return;
  if (!stage) return;
  const root = document.documentElement;
  const slides = [...stage.querySelectorAll('.slide')];
  const rail = document.querySelector('.rail');
  const railLinks = rail ? [...rail.querySelectorAll('a')] : [];
  const now = document.querySelector('.now');
  const DEFAULT_ACCENT = getComputedStyle(root).getPropertyValue('--accent').trim() || '#D4561E';
  let current = Math.max(0, slides.findIndex(s => '#' + s.id === location.hash));
  let tl = null, startedAt = -1e9;
  const COOLDOWN = 350; // ms: bir geçiş başladıktan sonra yeni hareketin kabul edilmesi için

  function chrome(i) {
    const s = slides[i];
    const isBrand = s.classList.contains('brand');
    const color = isBrand ? getComputedStyle(s).getPropertyValue('--brand').trim() : DEFAULT_ACCENT;
    root.style.setProperty('--accent', color || DEFAULT_ACCENT);
    if (rail) rail.dataset.hidden = isBrand ? 'false' : 'true';
    if (now) { now.dataset.hidden = isBrand ? 'false' : 'true'; if (isBrand) now.querySelector('b').textContent = s.dataset.name; }
    railLinks.forEach(a => a.setAttribute('aria-current', a.hash === '#' + s.id ? 'true' : 'false'));
    history.replaceState(null, '', '#' + s.id);
    if (isBrand) { if (s.__swipeRender) s.__swipeRender(); nudge(s); }
  }
  function parts(s) {
    return {
      plate: null,
      gs: [...s.querySelectorAll('.hp__fly, .panel:not([hidden]) .dish__img img')],
      copy: [...s.querySelectorAll('.copy > *, .panel:not([hidden]) .dish__txt > *, .swipe-ui')],
      giant: s.querySelector('.giant')
    };
  }
  function near(i) {
    slides.forEach((s, k) => s.classList.toggle('is-near', Math.abs(k - i) === 1));
    // açık markanın diğer kategorilerindeki görseller arka planda iner
    const s = slides[i];
    setTimeout(() => s.querySelectorAll('.panel[hidden] img[loading="lazy"]').forEach(img => { img.loading = 'eager'; }), 900);
  }
  function show(i) {
    slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.inert = k !== i; });
    near(i);
    chrome(i);
  }
  function goTo(i) {
    if (i < 0 || i >= slides.length || i === current) return false;
    if (performance.now() - startedAt < COOLDOWN) return false;
    if (tl && tl.isActive()) tl.progress(1); // süren geçiş sonuna atlanır, yenisi temiz başlar
    startedAt = performance.now();
    const dir = i > current ? 1 : -1;
    const from = slides[current], to = slides[i];
    current = i;
    chrome(i);
    to.classList.add('is-active'); to.inert = false; from.inert = true;
    near(i);
    if (!G) { from.classList.remove('is-active'); return true; }
    const a = parts(from), b = parts(to), vh = innerHeight;
    const outEls = [a.giant, ...a.gs, ...a.copy].filter(Boolean);
    tl = G.timeline({
      onComplete() {
        from.classList.remove('is-active');
        G.set(outEls, { clearProps: 'transform,opacity' });
        G.set([b.giant, ...b.gs, ...b.copy].filter(Boolean), { clearProps: 'transform,opacity' });
        G.set([from, to], { clearProps: 'opacity' });
      }
    });
    if (reduce) {
      tl.to(from, { opacity: 0, duration: .15 }).fromTo(to, { opacity: 0 }, { opacity: 1, duration: .2 });
      return true;
    }
    const speed = el => +(el.dataset.speed || 1);
    tl.to(a.copy, { y: -dir * 40, opacity: 0, duration: .25, stagger: { amount: .12 }, ease: 'power2.in' }, 0);
    tl.to(from, { opacity: 0, duration: .15, ease: 'none' }, .5); // eski markadan ekranda hiçbir şey kalmasın
    a.gs.forEach(g => tl.to(g, { y: -dir * vh * (1 + speed(g) * .5), rotate: dir * 30 * speed(g), duration: .65 - speed(g) * .1, ease: 'power2.in' }, 0));
    if (a.giant) tl.to(a.giant, { xPercent: -dir * 25, opacity: 0, duration: .6, ease: 'power2.in' }, 0);
    b.gs.forEach(g => tl.fromTo(g, { y: dir * vh * (1 + speed(g) * .6), rotate: -dir * 40 * speed(g) },
      { y: 0, rotate: 0, duration: .7 + speed(g) * .2, ease: 'power3.out' }, .18));
    if (b.giant) tl.fromTo(b.giant, { xPercent: dir * 25, opacity: 0 }, { xPercent: 0, opacity: 1, duration: .85, ease: 'power3.out' }, .22);
    tl.fromTo(b.copy, { y: dir * 40, opacity: 0 }, { y: 0, opacity: 1, duration: .5, stagger: { amount: .25 }, ease: 'power3.out' }, .55);
    return true;
  }
  const drawerOpen = () => drawer && drawer.classList.contains('is-open');
  const menuOpen = () => !!document.querySelector('.mobile-menu[open]') || qvOpen();

  // bir tekerlek hareketi = bir sahne; trackpad ataleti yok sayılır, yeni itiş hemen geçer
  let lastWheel = 0, lastStamp = 0, lastAbs = 0, consumed = false, acc = 0;
  addEventListener('wheel', e => {
    if (drawerOpen() || menuOpen() || e.target.closest('.drawer__body')) return;
    e.preventDefault();
    // İki olay arasındaki boşluk: işlenme anı farkı ile olayın kendi zaman damgası farkından küçüğü.
    // Geçiş sırasında sayfa meşgulken gecikmeli işlenen atalet olayları böylece "yeni hareket" sanılmaz.
    const t = performance.now(), d = Math.abs(e.deltaY);
    const stampGap = e.timeStamp - lastStamp;
    const gap = stampGap >= 0 ? Math.min(t - lastWheel, stampGap) : t - lastWheel;
    const fresh = gap > 150 || (consumed && d > lastAbs * 1.6 + 4 && t - startedAt > COOLDOWN);
    if (fresh) { consumed = false; acc = 0; }
    lastWheel = t; lastStamp = e.timeStamp; lastAbs = d;
    if (consumed) return;
    acc += e.deltaY;
    if (Math.abs(acc) > 20 && goTo(current + (acc > 0 ? 1 : -1))) consumed = true;
  }, { passive: false });

  // dikey kaydırma marka değiştirir; yatay kaydırma tabak sıralarına ve sekmelere kalır
  let tx = null, ty = null;
  addEventListener('touchstart', e => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
  addEventListener('touchmove', e => {
    if (ty === null || drawerOpen() || menuOpen()) return;
    const dx = Math.abs(e.touches[0].clientX - tx), dy = Math.abs(e.touches[0].clientY - ty);
    if (dy > dx) e.preventDefault();
  }, { passive: false });
  addEventListener('touchend', e => {
    if (ty === null || drawerOpen() || menuOpen()) { ty = tx = null; return; }
    const dy = ty - e.changedTouches[0].clientY, dx = tx - e.changedTouches[0].clientX; ty = tx = null;
    if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx)) goTo(current + (dy > 0 ? 1 : -1));
  });

  addEventListener('keydown', e => {
    if (drawerOpen() || menuOpen() || e.target.closest('input, textarea, select, [role="tab"]')) return;
    const k = e.key;
    if (k === 'ArrowDown' || k === 'PageDown' || (k === ' ' && !e.target.closest('a, button'))) { e.preventDefault(); goTo(current + 1); }
    else if (k === 'ArrowUp' || k === 'PageUp') { e.preventDefault(); goTo(current - 1); }
    else if (k === 'Home') { e.preventDefault(); goTo(0); }
    else if (k === 'End') { e.preventDefault(); goTo(slides.length - 1); }
  });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const i = slides.findIndex(s => '#' + s.id === a.hash);
    if (i > -1) { e.preventDefault(); goTo(i); }
  });

  // sofradaki tabağın üzerine gelince altında marka adı
  const cap = document.querySelector('.hero__caption');
  if (cap) {
    const capDefault = cap.textContent;
    document.querySelectorAll('.hp').forEach(p => {
      const on = () => { cap.textContent = p.dataset.label; cap.classList.add('is-on'); };
      const off = () => { cap.textContent = capDefault; cap.classList.remove('is-on'); };
      p.addEventListener('pointerenter', on); p.addEventListener('focus', on);
      p.addEventListener('pointerleave', off); p.addEventListener('blur', off);
    });
  }
  show(current);
})();
